import { useCallback, useEffect, useRef, useState } from 'react';
import Button from '../../../components/Button/Button';
import LoaderInline from '../../../components/Loader/LoaderInline';
import generateUserAgreement from '../../../api/creditPlatform/generateUserAgreement';
import DocsInputNew from '../../../components/Inputs/DocsInput/DocsInputNew';
import { textStyles } from '../../../constants/textStyles';
import uploadDocumentToDeal from '../../../api/deals/uploadDocumentToDeal';
import { DOCUMENT_STATUS_SIGNED, DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT } from '../../../constants';
import { socket } from '../../../App';
import generateLink from '../../../api/signature/generateLink';
import alert from '../../../helpers/alert';
import { humanErrorText } from '../../../helpers/errorText';
import extractErrorMessage from '../../../utils/extractErrorMessage';
import phoneBelongsIinValidate from '../../../api/bmg/phoneBelongsIinValidate';
import getClients from '../../../api/clients/getClients';
import { loadFreshClient, pickClientContact, BMG_UNAVAILABLE_MESSAGE } from '../../../utils/clientContact';
import { SIGN_TYPES } from '../../Public/SignDocuments';
import userSettings from '../../../api/clients/userSettings';

const SignatureType = ({ pickMobile, pickUpload, sendSmsForSign }) => {
  return (
    <>
      <p
        style={{
          ...textStyles.formTitle,
          marginBottom: 20,
          marginTop: 20,
        }}
      >
        ÐÐ»Ñ ÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð·Ð°ÑÐ²Ð¾Ðº Ð½Ð° ÐºÑÐµÐ´Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½Ñ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ
      </p>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        }}
      >
        <Button text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð² Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ð¼ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸" fill onClick={pickMobile} />
        <Button text="ÐÐ¾Ð´Ð¿Ð¸ÑÐ°ÑÑ Ð¸ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ" fill onClick={pickUpload} />
        <Button text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð­Ð¦Ð" fill onClick={() => sendSmsForSign(false)} />
        <Button text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ ÑÐµÑÐµÐ· OTP" fill onClick={() => sendSmsForSign(true)} />
      </div>
    </>
  );
};

const SigningLink = ({ link }) => {
  if (!link) return null;

  const copy = () => {
    navigator.clipboard.writeText(link).then(
      () => alert.success('Ð¡ÑÑÐ»ÐºÐ° ÑÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°Ð½Ð°'),
      () => alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°ÑÑ â Ð²ÑÐ´ÐµÐ»Ð¸ÑÐµ ÑÑÑÐ»ÐºÑ Ð¸ ÑÐºÐ¾Ð¿Ð¸ÑÑÐ¹ÑÐµ Ð²ÑÑÑÐ½ÑÑ')
    );
  };

  return (
    <div style={{ marginTop: 20, padding: 14, background: '#f7f7f8', borderRadius: 10 }}>
      <p style={{ fontSize: 14, color: '#6b6b70', margin: '0 0 8px' }}>
        Ð¡ÑÑÐ»ÐºÐ°, Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð½Ð°Ñ ÐºÐ»Ð¸ÐµÐ½ÑÑ. ÐÑÐ»Ð¸ Ð¡ÐÐ¡ Ð½Ðµ Ð´Ð¾ÑÐ»Ð° â Ð¿ÑÐ¾Ð´Ð¸ÐºÑÑÐ¹ÑÐµ Ð¸Ð»Ð¸ Ð¿ÐµÑÐµÑÐ»Ð¸ÑÐµ ÐµÑ ÑÐ°Ð¼Ð¸.
      </p>
      <p style={{ fontSize: 14, wordBreak: 'break-all', margin: '0 0 10px' }}>{link}</p>
      <Button text="Ð¡ÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°ÑÑ ÑÑÑÐ»ÐºÑ" onClick={copy} />
    </div>
  );
};

const SendAgreement = ({ onDocumentSigned, loading, signingLink }) => {
  // ÐÐ½Ð¾Ð¿ÐºÐ° Ð²ÑÐ·ÑÐ²Ð°Ð»Ð° Ð¾ÑÐ¿ÑÐ°Ð²ÐºÑ Ð½Ð°Ð¿ÑÑÐ¼ÑÑ, Ð¼Ð¸Ð½ÑÑ Ð·Ð°ÑÐ¸ÑÑ Ð¾Ñ Ð¿Ð¾Ð²ÑÐ¾ÑÐ°: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¶Ð°Ð» ÐµÑ,
  // Ð° Ð¿Ð°ÑÐ°Ð»Ð»ÐµÐ»ÑÐ½Ð¾ Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ð»Ð¾ ÑÐ¾Ð±ÑÑÐ¸Ðµ Ð¾ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ð¸ â Ð² Ð±Ð°Ð½ÐºÐ¸ ÑÑÐ¾Ð´Ð¸Ð»Ð¸ Ð´Ð²Ðµ Ð·Ð°ÑÐ²ÐºÐ¸.
  const [pressed, setPressed] = useState(false);
  // Ð¡Ð²Ð¾ÐµÐ¹ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐºÐ¸ Ð·Ð´ÐµÑÑ Ð½ÐµÑ Ð½Ð°Ð¼ÐµÑÐµÐ½Ð½Ð¾. Ð Ð°Ð½ÑÑÐµ ÑÐºÑÐ°Ð½ ÑÐ»ÑÑÐ°Ð» ÐºÐ°Ð½Ð°Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°, Ð°
  // ÐºÐ¾ÑÐµÐ½Ñ Ð¼Ð¾Ð´Ð°Ð»ÐºÐ¸ â ÐºÐ°Ð½Ð°Ð» ÑÐ´ÐµÐ»ÐºÐ¸, Ð¸ Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ Ð±ÑÐ»Ð° ÑÐ²Ð¾Ñ Ð·Ð°ÑÐ¸ÑÐ° Ð¾Ñ Ð¿Ð¾Ð²ÑÐ¾ÑÐ°:
  // ÑÐµÑÐ²ÐµÑ ÑÐ»ÑÑ ÑÐ¾Ð±ÑÑÐ¸Ðµ Ð² Ð¾Ð±Ð°, ÑÑÐ°Ð±Ð°ÑÑÐ²Ð°Ð»Ð¸ Ð¾Ð±Ð°, Ð¸ Ð² Ð±Ð°Ð½ÐºÐ¸ ÑÑÐ¾Ð´Ð¸Ð»Ð¸ Ð´ÑÐ±Ð»Ð¸ Ð·Ð°ÑÐ²Ð¾Ðº
  // (ÑÐ´ÐµÐ»ÐºÐ° 189953 Ð½Ð° Ð¿ÑÐ¾Ð´Ðµ). ÐÑÐ¿ÑÐ°Ð²ÐºÑ Ð´ÐµÐ»Ð°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾ÑÐµÐ½Ñ Ð¼Ð¾Ð´Ð°Ð»ÐºÐ¸.
  if (loading) return <LoaderInline />;

  return (
    <>
      <div
        style={{
          margin: 30,
        }}
      >
        <LoaderInline />
      </div>
      <p style={{ ...textStyles.formTitle, textAlign: 'center' }}>
        ÐÐ¶Ð¸Ð´Ð°ÐµÑÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼
      </p>

      <div
        style={{
          marginTop: 20,
        }}
      >
        <Button
          onClick={() => {
            if (pressed) return;
            setPressed(true);
            onDocumentSigned();
          }}
          disabled={pressed}
          text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð½Ð° ÐºÑÐµÐ´Ð¸Ñ"
          fill
          full
        />
      </div>

      <SigningLink link={signingLink} />
    </>
  );
};
const UploadAgreement = ({ deal, sendAppeal, agreementFile, onClose }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = () => {
    setLoading(true);
    uploadDocumentToDeal({
      dealId: deal?.id,
      statusId: DOCUMENT_STATUS_SIGNED,
      fileTypeId: DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT,
      file,
      signed: true,
    })
      .then(() => {
        sendAppeal().finally(() => setLoading(false));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  if (!agreementFile || loading) return <LoaderInline />;

  return (
    <>
      <p style={{ ...textStyles.formTitle, textAlign: 'center', margin: '20px 0 40px 0' }}>
        ÐÐ¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼
      </p>
      <div
        style={{
          marginBottom: 20,
        }}
      >
        <div style={{ marginBottom: 20, marginTop: 20, display: 'flex', justifyContent: 'center' }}>
          <a
            href={agreementFile}
            target="_blank"
            style={{
              gap: 7,
              display: 'inline-grid',
              gridTemplateColumns: 'auto 1fr',
              alignItems: 'center',
              marginBottom: 5,
            }}
            rel="noreferrer"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
              <path
                d="M2 16H18V9H20V17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V9H2V16ZM12 6H17L10 13L3 6H8V0H12V6Z"
                fill="var(--brand-primary)"
              />
            </svg>
            <a style={{ color: 'var(--brand-primary)', fontSize: 16, fontWeight: 400 }}>
              Ð¡ÐºÐ°ÑÐ°ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ
            </a>
          </a>
        </div>
        <DocsInputNew
          id="agreement"
          label={file?.name || 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð½Ð¾Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ'}
          onChange={setFile}
        />
      </div>
      <div
        style={{
          display: 'flex',
          gap: 15,
        }}
      >
        <Button text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ" fill disabled={!file || loading} onClick={onSubmit} />
        <Button
          text="ÐÐ°Ð·Ð°Ð´"
          disabled={loading}
          onClick={onClose}
          style={{ color: 'var(--brand-primary)', border: '1px solid var(--brand-primary)' }}
        />
      </div>
    </>
  );
};

const DealCreateAgreement = ({ deal, sendAppeal, onClose, sendFormLoading, bankIds, creditAppeal }) => {
  const [step, setStep] = useState(1);
  const [agreementDocumentId, setAgreementDocumentId] = useState(null);
  // Ð¡ÑÑÐ»ÐºÐ°, Ð²ÑÐ´Ð°Ð½Ð½Ð°Ñ ÐºÐ»Ð¸ÐµÐ½ÑÑ. ÐÐ· Ð¾ÑÐ²ÐµÑÐ° ÑÐµÑÐ²ÐµÑÐ° â Ð½Ð° ÑÐµÐºÑÑÐµÐ¹ ÑÑÑÐ°Ð½Ð¸ÑÐµ, Ð¸Ð· ÑÐ´ÐµÐ»ÐºÐ¸ â
  // Ð¿Ð¾ÑÐ»Ðµ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ¸: ÑÐ°Ð¼ Ð¾Ð½Ð° ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð°.
  const [signingLink, setSigningLink] = useState(null);
  const [loading, setLoading] = useState(false);

  // ÐÐ¾Ð´Ð¿Ð¸ÑÐºÐ° Ð½Ð° ÐºÐ°Ð½Ð°Ð» ÑÐ´ÐµÐ»ÐºÐ¸ Ð¶Ð¸Ð²ÑÑ Ð² ÐºÐ¾ÑÐ½Ðµ Ð¼Ð¾Ð´Ð°Ð»ÐºÐ¸, Ð° Ð½Ðµ Ð½Ð° ÑÐºÑÐ°Ð½Ðµ Ð¾Ð¶Ð¸Ð´Ð°Ð½Ð¸Ñ:
  // ÑÐ¾Ñ ÑÐ¸ÑÑÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð½Ð° ÑÐ²Ð¾ÑÐ¼ ÑÐ°Ð³Ðµ, Ð¸ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÑÑÐ°Ð½Ð¸ÑÑ ÑÐ°Ð³
  // ÑÐ±ÑÐ°ÑÑÐ²Ð°ÐµÑÑÑ â Ð¿Ð¾Ð´Ð¿Ð¸ÑÐºÐ¸ Ð½Ðµ Ð±ÑÐ»Ð¾ Ð²Ð¾Ð²ÑÐµ, Ð¸ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð½Ð°Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼ Ð·Ð°ÑÐ²ÐºÐ° Ð½Ðµ
  // ÑÑÐ¾Ð´Ð¸Ð»Ð° (ÑÐ´ÐµÐ»ÐºÐ¸ 189939 Ð¸ 189942 Ð½Ð° Ð¿ÑÐ¾Ð´Ðµ).
  const appealSentRef = useRef(false);
  useEffect(() => {
    if (!deal?.id) return undefined;
    const channel = 'listenSignatureInDeal' + deal.id;
    socket.on(channel, (data) => {
      if (data && data.success === false) {
        alert.error(
          data.message || 'ÐÐ»Ð¸ÐµÐ½Ñ Ð½Ðµ Ð·Ð°Ð²ÐµÑÑÐ¸Ð» Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ. ÐÐ¾Ð¶Ð½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÑÑÐ»ÐºÑ Ð·Ð°Ð½Ð¾Ð²Ð¾',
          { autoClose: false, closeOnClick: false }
        );
        return;
      }
      // ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼ Ð¾Ð´Ð¸Ð½ ÑÐ°Ð·: ÑÐ¾Ð±ÑÑÐ¸Ðµ Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ Ð¸ Ð¿Ð¾ ÐºÐ°Ð½Ð°Ð»Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ° ÑÐ¾Ð¶Ðµ, Ð°
      // Ð´Ð²Ð¾Ð¹Ð½Ð¾Ð¹ Ð²ÑÐ·Ð¾Ð² ÑÐ¾Ð·Ð´Ð°Ð» Ð±Ñ Ð´ÑÐ±Ð»Ð¸ Ð·Ð°ÑÐ²Ð¾Ðº Ð² Ð±Ð°Ð½ÐºÐ°Ñ.
      if (appealSentRef.current) return;
      appealSentRef.current = true;
      sendAppeal();
    });
    return () => {
      socket.off(channel);
    };
  }, [deal?.id, sendAppeal]);

  console.log('bankIds', bankIds);

  const pickMobile = () => {
    setLoading(true);
    generateUserAgreement({ userid: deal?.client?.id, chunkId: deal?.chunkId, bankIds, creditAppeal })
      .then((res) => {
        setAgreementDocumentId(res?.data?.documentId);
        setStep('mobile');
      })
      .catch((err) => {
        if (!humanErrorText(err?.response?.data)) {
          alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ³ÐµÐ½ÐµÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ');
        }
      })
      .finally(() => setLoading(false));
  };

  const [agreementFile, setAgreementFile] = useState(null);
  const pickUpload = () => {
    generateUserAgreement({ userid: deal?.client?.id, chunkId: deal?.chunkId, bankIds, creditAppeal })
      .then((res) => {
        if (!res?.data?.url) {
          alert('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ³ÐµÐ½ÐµÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ');
          return;
        }
        setAgreementFile(res?.data?.url);
        window.open(res?.data?.url, '_blank');

        setStep('upload');
      })
      .catch((err) => {
        if (!humanErrorText(err?.response?.data)) {
          alert.error(
            extractErrorMessage(err?.response?.data) ||
              'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ³ÐµÐ½ÐµÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ'
          );
        }
      });
  };

  const onDocumentSigned = () => {
    sendAppeal();
  };

  const sendSmsForSign = async (otp) => {
    setLoading(true);

    try {
      // ÐÐ»Ð¸ÐµÐ½ÑÐ° Ð¿ÐµÑÐµÑÐ¸ÑÑÐ²Ð°ÐµÐ¼ Ñ ÑÐµÑÐ²ÐµÑÐ°: ÑÑÑÐ°Ð½Ð¸ÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸ Ð¿Ð¾Ð¼Ð½Ð¸Ñ ÑÐµÐ»ÐµÑÐ¾Ð½ Ñ Ð¼Ð¾Ð¼ÐµÐ½ÑÐ°
      // Ð¾ÑÐºÑÑÑÐ¸Ñ, Ð° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¼Ð¾Ð³ ÑÐ¼ÐµÐ½Ð¸ÑÑ ÐµÐ³Ð¾ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ (ÑÐ´ÐµÐ»ÐºÐ° 191883).
      const freshClient = await loadFreshClient(getClients, deal?.client?.id);
      const isPhoneBelongsToClient = await phoneBelongsIinValidate(
        pickClientContact(freshClient, deal?.client)
      );

      if (!isPhoneBelongsToClient) {
        alert.error('ÐÐ»Ð¸ÐµÐ½Ñ Ñ ÑÑÐ¸Ð¼ ÐÐÐ Ð½Ðµ ÑÐ²Ð»ÑÐµÑÑÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐµÐ¼ Ð²Ð²ÐµÐ´ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð½Ð¾Ð¼ÐµÑÐ° ÑÐµÐ»ÐµÑÐ¾Ð½Ð°');
        setLoading(false);
        return;
      }
    } catch (e) {
      alert.error(BMG_UNAVAILABLE_MESSAGE);
      setLoading(false);
      return;
    }

    generateUserAgreement({ userid: deal?.client?.id, chunkId: deal?.chunkId, bankIds, creditAppeal })
      .then((res) => {
        // ÐÐ»Ð¸ÐµÐ½Ñ ÑÐ¶Ðµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ²Ð°ÐµÑ: Ð±ÑÐºÐµÐ½Ð´ Ð½Ðµ ÑÑÐ°Ð» Ð¿ÐµÑÐµÑÐ¾Ð·Ð´Ð°Ð²Ð°ÑÑ Ð¿Ð°ÐºÐµÑ, Ð° Ð¿ÑÐ¾Ð´ÑÐ±Ð»Ð¸ÑÐ¾Ð²Ð°Ð»
        // ÐºÐ»Ð¸ÐµÐ½ÑÑ Ð¿ÑÐµÐ¶Ð½ÑÑ ÑÑÑÐ»ÐºÑ. ÐÐ¾Ð²ÑÑ Ð²ÑÐ¿ÑÑÐºÐ°ÑÑ Ð½ÐµÐ»ÑÐ·Ñ â Ð¾Ð½Ð° Ð¾Ð±Ð½ÑÐ»Ð¸Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ.
        if (res?.data?.resent) {
          alert.success(res?.data?.message || 'Ð¡ÑÑÐ»ÐºÐ° Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÑ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾');
          if (res?.data?.link) setSigningLink(res.data.link);
          // Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¾Ð±ÐµÑÐ°ÐµÑ ÑÑÑÐ»ÐºÑ Â«Ð½Ð¸Ð¶ÐµÂ», Ð° Ð¾Ð½Ð° Ð¶Ð¸Ð²ÑÑ Ð½Ð° ÑÐºÑÐ°Ð½Ðµ Ð¾Ð¶Ð¸Ð´Ð°Ð½Ð¸Ñ â
          // Ð½Ð° ÑÐºÑÐ°Ð½Ðµ Ñ ÐºÐ½Ð¾Ð¿ÐºÐ°Ð¼Ð¸ ÐµÑ Ð½ÐµÑ. ÐÐµÑÐµÐ²Ð¾Ð´Ð¸Ð¼ ÑÑÐ´Ð°, Ð¸Ð½Ð°ÑÐµ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ° Ð²ÑÑÑ.
          setStep('mobile');
          setLoading(false);
          return;
        }
        if (!res?.data?.url) {
          alert.error(
            'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ³ÐµÐ½ÐµÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ. ÐÑÑÑÑÑÑÐ²ÑÐµÑ ÑÑÑÐ»ÐºÐ° Ð½Ð° Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ'
          );
          setLoading(false);
          return;
        }
        setAgreementDocumentId(res?.data?.documentId?.[0]);
        generateLink({
          url: res?.data?.url,
          name: 'docs',
          typeId: DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT,
          documentId: res?.data?.documentId?.[0],
          userId: deal?.client?.id,
          dealId: deal?.id,
          signType: otp ? SIGN_TYPES.OTP : SIGN_TYPES.ECP,
          bankIds,
        })
          .then((linkRes) => {
            if (linkRes?.data?.link) setSigningLink(linkRes.data.link);
            alert.success('Ð¡ÐÐ¡ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾');
            setStep('mobile');
          })
          .catch(() => {
            alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð¡ÐÐ¡');
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch((err) => {
        // ÐÐ¾Ð½ÑÑÐ½ÑÑ Ð¿ÑÐ¸ÑÐ¸Ð½Ñ ÑÐ¶Ðµ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð» Ð¿ÐµÑÐµÑÐ²Ð°ÑÑÐ¸Ðº Ð² api.js â ÑÐ²Ð¾Ð¹ Ð¾Ð±ÑÐ¸Ð¹ ÑÐµÐºÑÑ
        // Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¾Ð³Ð´Ð°, ÐºÐ¾Ð³Ð´Ð° ÑÐµÑÐ²ÐµÑ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¾Ð±ÑÑÑÐ½Ð¸Ð». ÐÐ½Ð°ÑÐµ
        // Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¿Ð¾Ð»ÑÑÐ°ÐµÑ Ð´Ð²Ð° ÑÐ¾ÑÑÐ° Ð¿Ð¾Ð´ÑÑÐ´.
        if (!humanErrorText(err?.response?.data)) {
          alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ³ÐµÐ½ÐµÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ');
        }
        setLoading(false);
      });
  };

  if (loading) {
    return <LoaderInline />;
  }

  return (
    <>
      {step === 1 && <SignatureType pickMobile={pickMobile} pickUpload={pickUpload} sendSmsForSign={sendSmsForSign} />}
      {step === 'mobile' && (
        <SendAgreement
          onDocumentSigned={onDocumentSigned}
          loading={sendFormLoading}
          signingLink={signingLink || deal?.signingLink}
        />
      )}
      {step === 'upload' && (
        <UploadAgreement
          setStep={setStep}
          deal={deal}
          sendAppeal={sendAppeal}
          agreementFile={agreementFile}
          onClose={onClose}
        />
      )}
    </>
  );
};

export default DealCreateAgreement;

